<template>
  <br />
  <div
    style="
      display: flex;
      justify-content: space-between;
      background-color: #f0f0f0;
      padding: 10px;
      border-radius: 5px;
    "
  >
    <h4 style="margin: 0">Renovación de Suscripción: Términos y Condiciones</h4>
    <h4 style="margin: 0">
      <span class="badge bg-primary">&nbsp;</span>
      <span class="badge bg-primary">2</span>
      <span class="badge bg-primary">&nbsp;</span>
      <span class="badge bg-primary">&nbsp;</span>
    </h4>
  </div>
  <hr />
  <div class="progress">
    <div
      class="progress-bar"
      role="progressbar"
      aria-label="Progress"
      style="width: 50%"
      aria-valuenow="50"
      aria-valuemin="0"
      aria-valuemax="100"
    ></div>
  </div>
  <br />
  <br />
  <div class="container">
    <form class="row g-3 needs-validation" novalidate>
      <div class="mb-3 text-area">
        <div class="form-control text-content" id="texto" readonly>
          <p>
            <strong
              >Términos y Condiciones de Uso de [Nombre de la
              Aplicación]</strong
            >
          </p>
          <p><strong>Introducción</strong></p>
          <p>
            Gracias por elegir [nombre de la empresa] para la gestión de
            atenciones médicas ambulatorias. Al utilizar nuestro servicio,
            aceptas estar vinculado por estos términos y condiciones, que
            protegen tanto tus derechos como los nuestros. Si no estás de
            acuerdo con alguna parte de estos términos, no podrás acceder al
            servicio.
          </p>
          <p><strong>Licencia de Uso</strong></p>
          <p>
            [Nombre de la empresa] te concede una licencia limitada, no
            exclusiva e intransferible para acceder y utilizar nuestra
            aplicación y servicios para fines de registro y gestión de
            atenciones médicas bajo las regulaciones de confidencialidad y
            privacidad aplicables.
          </p>
          <p><strong>Restricciones de Uso</strong></p>
          <ul>
            <li>
              No debes utilizar la aplicación para ningún propósito ilegal ni
              transmitir datos ilícitos, como información de salud sin
              consentimiento adecuado.
            </li>
            <li>
              No debes intentar alterar o interceptar cualquier dato o
              información transmitida hacia o desde la aplicación.
            </li>
            <li>
              No debes descompilar, realizar ingeniería inversa o intentar
              obtener el código fuente de nuestra aplicación.
            </li>
          </ul>
          <p><strong>Uso Aceptable</strong></p>
          <p>
            Debes utilizar la aplicación únicamente para el propósito para el
            que fue diseñada: la gestión de atenciones médicas. Cualquier uso
            fraudulento o inadecuado puede resultar en la terminación de tu
            acceso.
          </p>
          <p><strong>Confidencialidad y Privacidad de los Datos</strong></p>
          <p>
            Valoramos la privacidad y seguridad de los datos que nos confías.
            Nuestra política de privacidad, que es parte de estos términos,
            describe cómo manejamos la información personal y los datos de salud
            que recopilamos.
          </p>
          <p><strong>Limitaciones de Responsabilidad</strong></p>
          <p>
            [Nombre de la empresa] no será responsable de cualquier daño
            indirecto, especial o consecuente que resulte del uso o la
            incapacidad de uso de nuestros servicios, incluso si se ha advertido
            de la posibilidad de tales daños.
          </p>
          <p><strong>Modificaciones a los Términos</strong></p>
          <p>
            Podemos modificar estos términos y condiciones en cualquier momento
            para reflejar cambios en la ley o en nuestros servicios, siendo tu
            responsabilidad revisarlos periódicamente. El uso continuado del
            servicio después de tales cambios constituirá tu consentimiento a
            dichas modificaciones.
          </p>
          <p><strong>Legislación Aplicable</strong></p>
          <p>
            Estos términos se regirán e interpretarán de acuerdo con las leyes
            del Estado [Nombre del Estado/País], sin dar efecto a ningún
            principio de conflictos de ley.
          </p>
          <p>
            Estamos comprometidos a resolver cualquier disputa de manera justa y
            rápida.
          </p>
        </div>
      </div>
      <div class="col-12 d-flex justify-content-between align-items-center">
        <div>
          <input
            class="form-check-input"
            type="checkbox"
            value=""
            id="invalidCheck"
            required
            v-model="checked"
          />
          <label class="form-check-label" for="invalidCheck">
            Acepto los términos y condiciones.
          </label>
          <div class="invalid-feedback">
            Debes aceptar los términos y condiciones para continuar.
          </div>
        </div>
        <button
          class="btn btn-primary"
          type="button"
          @click="aceptarTC()"
          :disabled="!checked"
        >
          Continuar >
        </button>
      </div>
    </form>
  </div>
</template>
<script>
//import axios from 'axios'
export default {
  data() {
    return {
      usuario: {},
      checked: false,
    };
  },
  methods: {
    async aceptarTC() {
      //        await api.post('/usuarios', this.usuario)
      window.sessionStorage.setItem("registro_terminos", "SI");
      this.$router.push("Renovacion03FP");
    },
  },
};
</script>

<style src="@/assets/css/registro02TC.css" scoped></style>
